<template>
	<div class="text-justify">
		<app-tab
			ref="horizontalTabRef"
			:tabs="tabs"
			type="horizontal"
			:elevated="false"
			tabClass="px-4 py-3"
		/>
	</div>
</template>

<script>
/* TODO:
1. passing props rowData to child component DONE:
2. disabled all tab except placement booking and enable it when user click from action table placement booking
3. adjust placementBookingTableSchema to dynamically set callbackId based on placement_type DONE:
*/
export default {
	name: "LeadTabPlacement",
	// inject: ['eventHub'],
	props: {
		value: {
			type: Object,
			default: () => {
				return {
					code: "",
					name: "",
					is_active: "",
				};
			},
		},
	},
	data() {
		return {
			leadProfilePlacementSubTabLists: [],
			tabs: [],
		};
	},
	created() {

		// this.eventHub.$emit('bookingOyo', $val);

		// this.eventHub.$on('bookingOyo', $val => {
		// 	console
		// })

		this.leadProfilePlacementSubTabLists = [
			{ id: "placement-booking", function: this.goToPlacementBooking },
			{ id: "class-trial", function: this.goToClassTrial },
			{ id: "placement-test", function: this.goToPlacementTest },
			{ id: "direct-placement", function: this.goToDirectPlacement },
		];

		this.tabs = [
			{
				name: "Booking",
				component: "lead-profile-tab-placement-placement-booking",
				permission: "",
				props: {
					value: this.value,
					leadProfilePlacementSubTabLists:
						this.leadProfilePlacementSubTabLists,
				},
			},
			{
				name: "Class Trial",
				component: "lead-profile-tab-placement-class-trial",
				permission: "",
				isShow: false,
			},
			{
				name: "Placement Test",
				component: "lead-profile-tab-placement-placement-test",
				permission: "",
				isShow: false,
			},
			{
				name: "Direct Placement",
				component: "lead-profile-tab-placement-direct-placement",
				permission: "",
				isShow: false,
			},
		];
	},
	methods: {
		goToPlacementBooking(rowData) {
			this.$refs.horizontalTabRef.$children[0].loadTab(
				{
					name: "Placement Booking",
					component: "lead-profile-tab-placement-placement-booking",
					permission: "",
					props: {
						rowData: rowData,
					},
				},
				1
			);
		},
		goToClassTrial(rowData) {
			this.$refs.horizontalTabRef.$children[0].loadTab(
				{
					name: "Class Trial",
					component: "lead-profile-tab-placement-class-trial",
					permission: "",
					props: {
						rowData: rowData,
					},
				},
				1
			);
		},
		goToPlacementTest(rowData) {
			this.$refs.horizontalTabRef.$children[0].loadTab(
				{
					name: "Placement Test",
					component: "lead-profile-tab-placement-placement-test",
					permission: "",
					props: {
						rowData: rowData,
					},
				},
				2
			);
		},
		goToDirectPlacement(rowData) {
			this.$refs.horizontalTabRef.$children[0].loadTab(
				{
					name: "Direct Placement",
					component: "lead-profile-tab-placement-direct-placement",
					permission: "",
					props: {
						rowData: rowData,
					},
				},
				3
			);
		},
	},
};
</script>
